export const themeClasses = {
  textPrimary: 'text-zinc-950 dark:text-white',
  textSecondary: 'text-zinc-700 dark:text-zinc-300',
  textSubtle: 'text-zinc-500 dark:text-zinc-400',
  textMuted: 'text-zinc-500 dark:text-zinc-400',
  textFaint: 'text-zinc-400 dark:text-zinc-500',
  dividerSoftBackground: 'bg-zinc-950/5 dark:bg-white/10',
  dividerBorder: 'border-zinc-950/10 dark:border-white/10',
  dividerBorderSoft: 'border-zinc-950/5 dark:border-white/5',
  popoverSurface: 'bg-white/75 backdrop-blur-xl dark:bg-zinc-800/75',
  popoverRing: 'ring-zinc-950/10 dark:ring-white/10',
  itemIconFillMuted: '*:data-[slot=icon]:fill-zinc-500 dark:*:data-[slot=icon]:fill-zinc-400',
  itemIconTextMuted: '*:data-[slot=icon]:text-zinc-500 dark:*:data-[slot=icon]:text-zinc-400',
  itemCurrentIconFill: 'data-current:*:data-[slot=icon]:fill-zinc-950 dark:data-current:*:data-[slot=icon]:fill-white',
  indicatorStrong: 'bg-zinc-950 dark:bg-white',
  tableStripe: 'even:bg-zinc-950/2.5 dark:even:bg-white/2.5',
  tableHoverStriped: 'hover:bg-zinc-950/5 dark:hover:bg-white/5',
  tableHoverDefault: 'hover:bg-zinc-950/2.5 dark:hover:bg-white/2.5',
  inputTypography: 'text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6 dark:text-white',
  selectOptionSurface: 'dark:*:bg-zinc-800',
  badgeZinc:
    'bg-zinc-600/10 text-zinc-700 group-data-hover:bg-zinc-600/20 dark:bg-white/5 dark:text-zinc-400 dark:group-data-hover:bg-white/10',
  switchTrackNeutral: 'bg-zinc-200 ring-1 ring-black/5 ring-inset dark:bg-white/5 dark:ring-white/15',
  inputDisabled:
    'data-disabled:border-zinc-950/20 dark:data-disabled:border-white/15 dark:data-disabled:bg-white/2.5 dark:data-hover:data-disabled:border-white/15',
} as const
